(() => {
 const normalize = s => s.normalize('NFD').replace(/[\u0300-\u036f]/g,'').toLocaleLowerCase('it').replace(/[^a-z0-9]+/g,' ').trim();
 function init(scope=document) {
  scope.querySelectorAll('.ida-product-search').forEach(form => {
   if(form.dataset.ready) return;
   form.dataset.ready='true';
   const root=form.closest('collection-component'), input=form.querySelector('input'), reset=form.querySelector('button'), status=form.querySelector('[role="status"]');
   let visible=[];
   const filter=()=>{
    const query=normalize(input.value), words=query.split(' ').filter(Boolean);
    visible=[...root.querySelectorAll('[data-perfume-name]')].filter(card=>{
     const name=normalize(card.dataset.perfumeName), match=words.every(word=>name.includes(word));
     card.hidden=!match;
     if(query && match) card.classList.remove('scroll-trigger','animate--slide-in');
     return match;
    });
    reset.hidden=!input.value;
    status.textContent=!query?'':visible.length===0?'Nessun profumo trovato tra i prodotti selezionati. Prova un altro nome o modifica i filtri.':visible.length===1?'1 profumo trovato · premi Invio per scoprirlo.':`${visible.length} profumi trovati`;
   };
   form.hidden=false;
   input.addEventListener('input',filter);
   input.addEventListener('search',filter);
   reset.addEventListener('click',()=>{input.value='';filter();input.focus();});
   form.addEventListener('submit',e=>{e.preventDefault();if(normalize(input.value)&&visible.length===1){const a=visible[0].querySelector('a[href*="/products/"]');if(a)window.location.assign(a.href);}});
   const grid=root.querySelector('#ProductGridContainer');
   if(grid)new MutationObserver(filter).observe(grid,{childList:true,subtree:true});
   filter();
  });
 }
 init();document.addEventListener('shopify:section:load',e=>init(e.target));
})();
